import { useAppConfigStore } from '@/stores/appConfig'
import { toastify } from './toastify'

function buildCustomerServiceUrl(rawUrl: string) {
  const url = new URL(rawUrl, window.location.origin)
  url.searchParams.set('parentOrigin', window.location.origin)
  return url.toString()
}
export function openCsUrl() {
  const cs_url = useAppConfigStore().config?.cs_url
  console.log(cs_url, useAppConfigStore().config)
  if (!cs_url) {
    toastify({ message: '无客服链接，请刷新重试', type: 'danger' })
    return
  }
  try {
    // iframeSrc.value = buildCustomerServiceUrl(url)
    window.open(buildCustomerServiceUrl(cs_url), 'KWCustomerService')
  } catch {
    toastify({ message: '客服加载失败，请稍后重试', type: 'danger' })
  }
}
